import { NgClass, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BoxComponent } from '../box/box.component';
import { BaseComponent } from '../base-component';
import { InAppNotification } from '@shared/models/app-notifications.model';
import { AppNotificationService } from '@shared/services/app-notification.service';
import { TimeElapsedPipe } from '@shared/pipes/time-elapsed.pipe';
import { MatListModule } from '@angular/material/list';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ViewsService } from '@shared/services/views.service';
import { PipelineView } from '../../../deal-pipeline/components/deal-pipeline/models/pipeline-view';
import { Router } from '@angular/router';
import { provideTranslocoScope, TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-notifications-content',
    templateUrl: './app-notifications-content.component.html',
    styleUrls: ['./app-notifications-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [provideTranslocoScope('sharedNav')],
    imports: [
    MatSidenavModule,
    MatCardModule,
    BoxComponent,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    MatMenuModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    MatTooltipModule,
    CommonModule,
    TimeElapsedPipe,
    MatListModule,
    TranslocoPipe
]
})

export class AppNotificationsContentComponent extends BaseComponent implements OnDestroy {
  public safeHtml: SafeHtml | null = null;
  private _inAppNotificationsData!: InAppNotification[];
  @Input() set inAppNotificationsData(value: InAppNotification[]) {
    this._inAppNotificationsData = value;
  }
  get inAppNotificationsData(): InAppNotification[] {
    return this._inAppNotificationsData;
  }

  @Input() notificationAggregator!: string;

  @Output() public onMarkAsReadNotification = new EventEmitter<number>();
  @Output() public onMarkAsUnReadNotification = new EventEmitter<number>();


  constructor(
    private appNotificationService: AppNotificationService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private viewsService: ViewsService,
  ) { super() }


  public onDelete(notificationId: number) {
    this.appNotificationService.deleteNotification(notificationId);
  }

  public onMarkAsRead(notificationId: number) {
    this.onMarkAsReadNotification.emit(notificationId);
  }

  ngAfterVIewInit() {

  }

  moveToPipeline(id: PipelineView['id']) {
    const element = document.getElementById('dealPipeline');
    if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    
    setTimeout(() => {
      window.scrollBy({
        top: -500,
        behavior: 'smooth'
      });
    }, 100);
      this.viewsService.setSharedViewId(+id);
    } else {
      this.router.navigate(['/home']).then(() => {
        this.viewsService.setSharedViewId(+id);
      });
    }
  }

  renderSafeHtml(notificationSafeHtml: SafeHtml, content: any): SafeHtml {
     let htmlString: string;
  
  if (notificationSafeHtml && typeof notificationSafeHtml === 'object' && (notificationSafeHtml as any).changingThisBreaksApplicationSecurity) {
    htmlString = (notificationSafeHtml as any).changingThisBreaksApplicationSecurity;
  } else {
    htmlString = notificationSafeHtml?.toString() || '';
  }

  if (content?.author || content?.filterName) {
    const processedHtml = htmlString
      .replace(/\$\$Author\$\$/g, content.author || 'Unknown Author')
      .replace(/\$\$FilterName\$\$/g, content.filterName || 'Unknown Filter');
    return this.sanitizer.bypassSecurityTrustHtml(processedHtml);
  } else {
    return this.sanitizer.bypassSecurityTrustHtml(htmlString);
  }

  }

  public onMarkAsUnRead(notificationId: number) {
    this.onMarkAsUnReadNotification.emit(notificationId);
  }

  public ngOnDestroy(): void {
    this.viewsService.setSharedViewId(null);
  }
}

